import * as DialogActions from "actions/dialog-actions";
import dialogTheme from "css/themes/dialogs/dialogBase.css";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Dialog from "react-toolbox/lib/dialog";
import { bindActionCreators } from "redux";
import ModalButtonGroup from "visual-components/util/buttons/ModalButtonGroup";
import { H4 } from "visual-components/util/texts";

const mapStateToProps = ({ incompleteRulesModal }) => ({ incompleteRulesModal });
const mapDispatchToProps = (dispatch) => ({
  dialogActions: bindActionCreators(DialogActions, dispatch),
});

class IncompleteRulesDialog extends Component {
  closeModal = () => {
    this.props.dialogActions.closeDialog("incompleteRulesModal");
  };

  navigateToRules = () => {
    const {
      incompleteRulesModal: { id },
      history,
    } = this.props;

    this.closeModal();
    history.push(`/builder/${id}/terms/dashboard`);
  };

  render() {
    const {
      incompleteRulesModal: { open, name },
    } = this.props;

    return (
      <Dialog
        title="Your Official Rules are Incomplete!"
        theme={dialogTheme}
        active={open}
        onEscDown={this.closeModal}
        onOverlayClick={this.closeModal}
      >
        <div className={`${dialogTheme.banner}`} style={{ paddingTop: "8px" }}>
          <img src="/images/icons/error-attention-banner.svg" />
        </div>

        <H4 multiline>
          Whoops! <i>{name}</i> isn't ready to go yet - your Official Rules are incomplete. Visit
          the Official Rules section to review and fix.
        </H4>

        <ModalButtonGroup
          canSave
          confirm={this.navigateToRules}
          confirmText={"Update Official Rules"}
          cancel={this.closeModal}
          cancelText={"Close"}
          hideLine
        />
      </Dialog>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(IncompleteRulesDialog));
